import { InputLabel, FormControl, Select, MenuItem } from "@mui/material"

export default function Selector({value, onChange, label, options, emptyOption, required, disabled, sx}){

    return <FormControl>
        <InputLabel>{label}</InputLabel>
        <Select
            label={label}
            size='small'
            value={value}
            onChange={onChange}
            sx={sx || {}}
            required={required ? true : false}
            disabled={disabled ? true : false}
            displayEmpty={emptyOption ? true : false}
        >
            {emptyOption && 
                <MenuItem value=''>{emptyOption}</MenuItem>
            }

            {options.map(o => 
                <MenuItem key={o.value} value={o.value}>{o.title}</MenuItem>    
            )}
        </Select>
    </FormControl>
}